<template>
  <div v-show="simulation.offerParams.isCreditInsuranceAccelerated" class="subcard is-gray">
    <div class="subcard-header">
      <p class="header-title">Cuota máxima</p>
      <b-button
        class="header-icon"
        size="is-small"
        :icon-left="localShow ? 'angle-up' : 'angle-down'"
        @click="toggle" />
    </div>

    <div v-show="localShow" class="subcard-content fields-has-text-right">
      <b-field class="has-addons" custom-class="columns">
        <div class="column is-4 is-flex is-align-items-center is-flex-direction-column">
          <small class="text-center has-text-grey-light pr-1">&nbsp;</small>
          <div class="field has-addons">
            <p class="control">
              <a class="button is-static">UF</a>
            </p>
            <b-input
              :disabled="readOnly"
              size="is-small"
              :type="determineInputType(firstFeeMaxPayment())"
              placeholder="Ingresa el valor"
              :value="firstFeeMaxPayment()"
              expanded />
          </div>
        </div>

        <div class="column is-4 is-flex is-align-items-center is-flex-direction-column">
          <small class="text-center has-text-grey-light pr-1">entre</small>
          <div class="field has-addons ">
            <p class="control">
              <a class="button is-static">Cuota</a>
            </p>
            <b-input
              :value="firstPaymentStart()"
              :disabled="readOnly"
              size="is-small"
              :type="determineInputType(firstPaymentStart())"
              placeholder="Ingresa el valor"
              expanded />
          </div>
        </div>
        <div class="column is-4 is-flex is-align-items-center is-flex-direction-column">
          <small class="text-center has-text-grey-light pr-1">y</small>
          <div class="field has-addons ">
            <p class="control">
              <a class="button is-static">Cuota</a>
            </p>
            <b-input
              :value="firstPaymentEnd()"
              :disabled="readOnly"
              size="is-small"
              :type="determineInputType(firstPaymentEnd())"
              placeholder="Ingresa el valor"
              expanded />
          </div>
        </div>
      </b-field>
      <b-field class="has-addons" custom-class="columns">
        <div class="column is-4 is-flex is-align-items-center is-flex-direction-column">
          <small class="text-center has-text-grey-light pr-1">&nbsp;</small>
          <div class="field has-addons">
            <p class="control">
              <a class="button is-static">UF</a>
            </p>
            <b-input
              :value="lastFeeMaxPayment()"
              :disabled="readOnly"
              size="is-small"
              :type="determineInputType(lastFeeMaxPayment())"
              placeholder="Ingresa el valor"
              expanded />
          </div>
        </div>

        <div class="column is-4 is-flex is-align-items-center is-flex-direction-column">
          <small class="text-center has-text-grey-light pr-1">entre</small>
          <div class="field has-addons ">
            <p class="control">
              <a class="button is-static">Cuota</a>
            </p>
            <b-input
              :value="lastPaymentStart()"
              :disabled="readOnly"
              size="is-small"
              :type="determineInputType(lastPaymentStart())"
              placeholder="Ingresa el valor"
              expanded />
          </div>
        </div>
        <div class="column is-4 is-flex is-align-items-center is-flex-direction-column">
          <small class="text-center has-text-grey-light pr-1">y</small>
          <div class="field has-addons ">
            <p class="control">
              <a class="button is-static">Cuota</a>
            </p>
            <b-input
              :value="lastPaymentEnd()"
              :disabled="readOnly"
              size="is-small"
              :type="determineInputType(lastPaymentEnd())"
              placeholder="Ingresa el valor"
              expanded />
          </div>
        </div>
      </b-field>
    </div>
  </div>
</template>

<script>
import { getSafe } from '@/application/services/get-safe';

export default {
  name: 'MaximumQuotaSubCard',
  props: {
    showContent: {
      type: Boolean,
      default: true
    },
    simulation: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    localShow: true
  }),
  computed: {
    amortizationSchedule() {
      return getSafe(this, 'simulation.amortizationSchedule', {});
    },
    amortizationScheduleRows() {
      return getSafe(this, 'simulation.amortizationScheduleRows', []);
    }
  },
  created() {
    this.localShow = this.showContent;
  },
  methods: {
    determineInputType(value) {
      return !Number.isNaN(parseFloat(value)) && Number.isFinite(value) ? 'number' : 'text';
    },
    toggle() {
      this.localShow = !this.localShow;
    },
    firstPaymentStart() {
      return 1;
    },
    firstPaymentEnd() {
      return this.amortizationSchedule.creditInsuranceNumberOfMonths;
    },
    lastPaymentStart() {
      return this.amortizationSchedule.creditInsuranceNumberOfMonths + 1;
    },
    lastPaymentEnd() {
      return this.amortizationSchedule.numberOfMonths;
    },
    firstFeeMaxPayment() {
      return getSafe(
        this,
        `amortizationScheduleRows[${getSafe(this, 'amortizationSchedule.numberOfGraceMonths', '---')}].monthlyTotal`, '---'
      );
    },
    lastFeeMaxPayment() {
      return getSafe(
        this,
        `amortizationScheduleRows[${getSafe(this, 'amortizationSchedule.creditInsuranceNumberOfMonths', '---')}].monthlyTotal`, '---'
      );
    }
  }
};
</script>

<style scoped>

</style>
